import { GameMode } from "../../GameMode.js";
import type { BotType } from "../../BotType.js";
import type { GameEndReason } from "../../GameEndReason.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { PlayerNo } from "../../PlayerNo.js";
import { LobbyStatus } from "./LobbyStatus.js";
import type { KnownLobbySettings } from "../../KnownLobbySettings.js";
import type { LobbyID } from "../../../lobby/LobbyID.js";
import type { RemoteLobbyStatus } from "./RemoteLobbyStatus.js";
import type { LocalLobbyStatus } from "./LocalLobbyStatus.js";


export class AnalysisLobbyStatus extends LobbyStatus {
    private readonly lobbyID: LobbyID;
    private readonly settings: KnownLobbySettings;
    private readonly endReason: GameEndReason;
    private readonly endingPlayer: PlayerType | null;
    private readonly completeGameID: string;

    constructor(
        lobbyID: LobbyID,
        settings: KnownLobbySettings,
        endReason: GameEndReason,
        endingPlayer: PlayerType | null,
        completeGameID: string,
    ) {
        super();
        if (!lobbyID.getSource().isCompletedGameID())
            throw new Error("Expected a complete game ID");

        this.lobbyID = lobbyID;
        this.settings = settings;
        this.endReason = endReason;
        this.endingPlayer = endingPlayer;
        this.completeGameID = completeGameID;
    }

    override isRemote(): this is RemoteLobbyStatus {
        return false;
    }

    override isLocal(): this is LocalLobbyStatus {
        return false;
    }

    override isAnalysis(): this is AnalysisLobbyStatus {
        return true;
    }

    override getLobbyID(): LobbyID {
        return this.lobbyID;
    }

    override hasEverConnected(): boolean {
        return true;
    }

    override isConnected(): boolean {
        return true;
    }

    override isGameAvailable(): boolean {
        return true;
    }

    override isGameUnknown(): boolean {
        return false;
    }

    override getGameMode(): GameMode {
        return this.settings.getMode();
    }

    override getBotType(): BotType | null {
        const mode = this.settings.getMode();
        return (mode === GameMode.COMPUTER ? this.settings.getBotType() : null);
    }

    override getEndReason(): GameEndReason {
        return this.endReason;
    }

    override getEndingPlayer(): PlayerType | null {
        return this.endingPlayer;
    }

    override hasPingTimes(): boolean {
        return false;
    }

    override getPlayer1LastPingTimeMs(): number {
        return 0;
    }

    override getPlayer2LastPingTimeMs(): number {
        return 0;
    }

    override getCompleteGameID(): string {
        return this.completeGameID;
    }

    override withCompleteGameID(_completeGameID: string | null): AnalysisLobbyStatus {
        throw new Error("AnalysisLobbyStatus does not support withCompleteGameID");
    }

    override withEnd(_abandonReason: GameEndReason, _abandoner: PlayerType): AnalysisLobbyStatus {
        throw new Error("AnalysisLobbyStatus does not support withEnd");
    }

    override getRematchRequestedBy(): PlayerNo | null {
        return null;
    }
}
